module.exports = __webpack_public_path__ + "static/2t-3314f037ec585a0354a92be96619c900.webp";